import React, { useState, useEffect } from 'react';
import { useAuth, needsPhoneNumber } from '../context/AuthContext';
import CompleteProfile from '../pages/CompleteProfile';

/**
 * Blocks every route of a signed-in account that has no phone number (Google
 * sign-ups, owners and staff alike) behind CompleteProfile. Rendering in place,
 * without navigating, lets the user land where they were going once done.
 */
export default function PhoneRequiredGate({ children }) {
  const { user } = useAuth();
  // Number just saved and its SMS code step open: the refreshed user already
  // carries the pending number, so the gate stays up until the step is closed.
  const [codeSentTo, setCodeSentTo] = useState(null);

  useEffect(() => {
    if (!user) setCodeSentTo(null);
  }, [user]);

  if (!user || (!codeSentTo && !needsPhoneNumber(user))) return children;

  return (
    <CompleteProfile
      codeSentTo={codeSentTo}
      onCodeSent={setCodeSentTo}
      onDone={() => setCodeSentTo(null)}
    />
  );
}
